import Vue from "vue";
import Vuex from "vuex";
// import router from "../router/index";
import axios from "axios";
import api from "@/api.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fanDeckCount: null,
    umDbCardList: [],
    umDbDeckList: [],
    umDbSetList: [],
    umDbBoardList: [],
    userProfile: null,
    userPreferences: {},
    userNotifications: {
      error: false,
      loading: false,
      data: [],
    },
  },
  getters: {
    isLoggedIn: (state) => {
      return state.userProfile !== null && state.userProfile.username !== null;
    },
    currentUser: (state, getters) => {
      return getters.isLoggedIn ? state.userProfile.username : null;
    },
  },
  mutations: {
    setFanDeckCount(state, totalDecks) {
      state.fanDeckCount = totalDecks;
    },
    setUmDbDeckList(state, deckList) {
      state.umDbDeckList = deckList;
    },
    setUmDbCardList(state, cardList) {
      state.umDbCardList = cardList;
    },
    setUmDbSetList(state, setList) {
      state.umDbSetList = setList;
    },
    setUmDbBoardList(state, boardList) {
      state.umDbBoardList = boardList;
    },
    setUserProfile(state, val) {
      state.userProfile = val;
    },
    setUserNotifications(state, { data, loading, error }) {
      state.userNotifications.data = data;
      state.userNotifications.loading = loading;
      state.userNotifications.error = error;
    },
    setPreference(state, payload) {
      Vue.set(state.userPreferences, payload.key, payload.value);
      localStorage.setItem(
        "user_preferences",
        JSON.stringify(state.userPreferences)
      );
    },
    initialiseStore(state) {
      const savedPrefs = localStorage.getItem("user_preferences");
      if (savedPrefs) {
        try {
          state.userPreferences = {
            ...state.userPreferences,
            ...JSON.parse(savedPrefs),
          };
        } catch (err) {
          console.error(err);
        }
      }
    },
  },
  actions: {
    async login(_, service) {
      // sign user in

      if (service === "google") {
        window.location.href = "/auth/login/google";
      } else if (service === "discord") {
        window.location.href = "/auth/login/discord";
      }

      // fetch user profile and set in state
      // dispatch("fetchUserProfile", user);
    },
    async checkLoggedIn({ commit }) {
      const userProfile = await axios.get("/auth/current_user");

      if (userProfile.data && userProfile.data.username) {
        commit("setUserProfile", userProfile.data);
      } else {
        commit("setUserProfile", null);
      }
    },
    async getNotificationSummary({ commit }) {
      commit("setUserNotifications", {
        data: [],
        error: false,
        loading: true,
      });
      try {
        const notifications = await api.getNotificationSummary();
        commit("setUserNotifications", {
          data: notifications,
          error: false,
          loading: false,
        });
      } catch {
        commit("setUserNotifications", {
          data: [],
          error: true,
          loading: false,
        });
      }
    },
    async initUmDbData({ commit }) {
      api
        .getDBDecks()
        .then((deckList) => commit("setUmDbDeckList", deckList.decks));
      api
        .getDBCards()
        .then((cardList) => commit("setUmDbCardList", cardList.cards));
      api.getDBSets().then((setList) => commit("setUmDbSetList", setList.sets));
      api
        .getDBBoards()
        .then((boardList) => commit("setUmDbBoardList", boardList.boards));
      // For set count
      api
        .getDecks({ perPage: 1 })
        .then((data) => commit("setFanDeckCount", data.total));
    },
  },
  modules: {},
});
